import React from 'react';
import { Button as ScrollLink } from 'react-scroll';

import Logo from './assets/logo.png?base64';

import styles from './part-header.module.scss';

export default function PartHeader() {
  return (
    <div className={styles.header}>
      <div className={styles.leftContainer}>
        <img
          className={styles.logo}
          src={Logo}
          alt="company logo"
        />
      </div>
     <div className={styles.rightSpacer} />
    </div>
  );
}
